export default __webpack_public_path__ + "static/card-6-f0349c7dd1e488971d1940177195fec1.png";